import { IComponentOptions } from 'angular';
import { RegentsPlanningStepperCtrl } from './regents-planning-stepper.controller';

export const RegentsPlanningStepperComponent: IComponentOptions = {
  bindings: {
    currentSchool: '<',
    courseDiffs: '<',
  },
  controller: RegentsPlanningStepperCtrl,
  template: require('./regents-planning-stepper.html'),
};
